import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./style.css";
import { FaRegTimesCircle } from "react-icons/fa";

function CustomModal({ toggle, show, title, body, footerButtons, id = "", preToggle = () => { } }) {
    return (
        <div >
            <Modal
                id={id}
                className="new-custom-modal"
                show={show}
                style={{ display: "flex", margin: "auto" }}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName="modal-center"
            >
                <Modal.Header>
                    <FaRegTimesCircle onClick={() => {
                        toggle();
                        preToggle();
                    }} />
                    {
                        title &&
                        <Modal.Title centered id="contained-modal-title-vcenter">
                            <h4>{title}</h4>
                        </Modal.Title>
                    }

                </Modal.Header>

                <Modal.Body>
                    {
                        body
                    }
                </Modal.Body>

                <Modal.Footer>
                    {/* <div className="footer-buttons-wrapper"> */}
                    {
                        footerButtons ? footerButtons.map((button, i) => {
                            return (
                                <Button
                                    key={"mfb-" + i}
                                    disabled={button.hasOwnProperty("disabled") ? button.disabled : false}
                                    className={`custom-btn ${button.className || ""}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        button.action();
                                    }}
                                >
                                    {button.label}
                                </Button>
                            )
                        }) : ""
                    }
                    {/* </div> */}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CustomModal;